<section  class="wrap-intro" style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/background-introducao-home.png'); background-size: cover;">
  <div appAppearOnScroll class="layout">
    <h1 class="title-page">Serviços veiculares pra sua empresa?				<span>Pense grande.</span></h1>
    <p class="description">Soluções em tecnologia, inteligência e informações em tudo que diz respeito a veículos.</p>
  </div>
</section>

<app-solutions></app-solutions>

<app-consults></app-consults>

<app-diferentials></app-diferentials>

<app-testimonials></app-testimonials>

<app-destaque-blog></app-destaque-blog>

<app-contact-box></app-contact-box>
